"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurarInterceptors = exports.sucessoMiddleware = exports.erroMiddleware = exports.requestMiddleware = void 0;
const errorHandler_1 = require("./errorHandler");
const headers_1 = require("./headers");
/**
 * Função responsável por preparar o request antes do envio
 * **/
const requestMiddleware = async (config, customHeaders) => {
    if (customHeaders && Object.keys(customHeaders).length) {
        config.headers = customHeaders;
    }
    else {
        config.headers = headers_1.getHeadersPadrao();
    }
    return config;
};
exports.requestMiddleware = requestMiddleware;
const erroMiddleware = (axiosError) => {
    axiosError.descricaoDoErro = errorHandler_1.getDescricaoDoErro(axiosError);
    return Promise.reject(axiosError);
};
exports.erroMiddleware = erroMiddleware;
/**
 * Função responsável por tratar request com sucesso
 * **/
const sucessoMiddleware = (response) => {
    response.sucesso = true;
    return response;
};
exports.sucessoMiddleware = sucessoMiddleware;
const configurarInterceptors = ({ axiosApi, validarRequestSaida = true, customHeaders = {}, }) => {
    if (validarRequestSaida) {
        axiosApi.interceptors.request.use((config) => exports.requestMiddleware(config, customHeaders));
    }
    axiosApi.interceptors.response.use((response) => exports.sucessoMiddleware(response), (error) => exports.erroMiddleware(error));
};
exports.configurarInterceptors = configurarInterceptors;
//# sourceMappingURL=interceptors.js.map